import React from 'react'
import { Columns, Column } from '@resurs/midas-react'
import PageWrapper from '../../../../internal/PageWrapper'
import { getText } from '../../../../internal/TextLabels'
import { rejectedAnimation } from '../../../../assets/animations'

const PaymentMethodNotAvailable = () => (
  <PageWrapper type="danger">
    <div
      style={{
        padding: '2rem',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ display: 'flex' }}>
        <img
          style={{ margin: '1rem 1rem 1rem 0' }}
          src={rejectedAnimation}
          alt="Reject animation"
        />
        <h4 style={{ margin: '2.2rem 1rem 0 0' }}>
          {getText('payApply.paymentMethodsNotAvailable.title')}
        </h4>
      </div>
      <Columns>
        <Column col>
          <div style={{ paddingRight: '4rem' }}>
            {getText('payApply.paymentMethodsNotAvailable.description')}
          </div>
        </Column>
      </Columns>
    </div>
  </PageWrapper>
)

export default PaymentMethodNotAvailable
